
<template>
  <el-form ref="form" :model="form" label-width="100px">
    <el-form-item prop="name" label="公告名称：">
      <el-input
        v-model="form.name"
        clearable
        style="width: 400px"
        :disabled="ifEdits"
        placeholder="请输入公告名称"
        maxlength="100"
        show-word-limit
      ></el-input>
    </el-form-item>
    <el-form-item label="公告内容："></el-form-item>
    <el-form-item label-width="0px" prop="content" style="position: relative">
      <quill-editor
        :disabled="ifEdits"
        ref="quillEditor"
        v-model="form.detailed"
        :options="options"
        @change="onEditorChange($event)"
        style="width: calc(100% - 40px); margin-left: 20px"
      >
        <div id="toolbar" slot="toolbar">
          <button class="ql-bold" title="加粗">Bold</button>
          <button class="ql-italic" title="斜体">Italic</button>
          <button class="ql-underline" title="下划线">underline</button>
          <button class="ql-strike" title="删除线">strike</button>
          <button class="ql-blockquote" title="引用"></button>
          <button class="ql-code-block" title="代码"></button>
          <button class="ql-list" value="ordered" title="有序列表"></button>
          <button class="ql-list" value="bullet" title="无序列表"></button>
          <button class="ql-indent" value="+1" title="首行缩进">indent</button>
          <select class="ql-header" title="段落格式">
            <option selected>段落</option>
            <option value="1">标题1</option>
            <option value="2">标题2</option>
            <option value="3">标题3</option>
            <option value="4">标题4</option>
            <option value="5">标题5</option>
            <option value="6">标题6</option>
          </select>
          <select class="ql-size" title="字体大小">
            <option value="10px">10px</option>
            <option value="12px">12px</option>
            <option value="14px">14px</option>
            <option value="16px" selected>16px</option>
            <option value="18px">18px</option>
            <option value="20px">20px</option>
          </select>
          <select class="ql-font" title="字体">
            <option value="SimSun" selected></option>
            <option value="SimHei"></option>
            <option value="Microsoft-YaHei"></option>
            <option value="KaiTi"></option>
            <option value="FangSong"></option>
            <option value="Arial"></option>
            <option value="Times-New-Roman"></option>
            <option value="sans-serif"></option>
          </select>
          <select class="ql-color" value="color" title="字体颜色"></select>
          <select
            class="ql-background"
            value="background"
            title="背景颜色"
          ></select>
          <select class="ql-align" value="align" title="对齐"></select>
          <button class="ql-clean" title="还原"></button>
        </div>
      </quill-editor>
    </el-form-item>
    <el-form-item label="附件上传：">
      <el-upload
        v-if="file === ''"
        class="upload-demo"
        :action="urlHost + '/zkfz/notice/saveOrUpdate'"
        ref="upload"
        :auto-upload="false"
        :http-request="uploadFn"
        :on-change="handleChange"
        :before-upload="beforeUpload"
        accept=""
        :file-list="file"
        :limit="1"
      >
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">
          只能上传doc、pdf、图片、压缩包，且不超过1个
        </div>
      </el-upload>
      <el-upload
        v-else
        class="upload-demo"
        :action="urlHost + '/zkfz/notice/saveOrUpdate'"
        ref="upload"
        :auto-upload="false"
        :http-request="uploadFn"
        :on-change="handleChange"
        :before-upload="beforeUpload"
        :on-preview="handlePreview"
        accept=""
        :limit="2"
        :file-list="file"
      >
        <el-button size="small" type="primary" v-if="isEdit"
          >点击上传</el-button
        >
        <div slot="tip" class="el-upload__tip" v-if="isEdit">
          只能上传doc、pdf、图片、压缩包，且不超过1个
        </div>
      </el-upload>
    </el-form-item>
    <!-- <el-form-item prop="groupName" label="面向小组：">
        <el-select size="small" clearable v-model="form.isZaiBian" placeholder="请选择小组" filterable>
            <el-option v-for="item in groundList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
    </el-form-item> -->
    <el-form-item prop="name" label="面向小组：">
      <el-select
        size="middle"
        multiple
        clearable
        :disabled="ifEdits"
        v-model="form.groups"
        @change="handlePlat"
        placeholder="请选择小组"
        filterable
        style="width: 400px"
      >
        <el-option label="全部" value="全部"></el-option>
        <el-option
          v-for="(item, index) in groundList"
          :key="index"
          :label="item.name"
          :value="String(item.id)"
          :disabled="item.disabled"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item
      prop="effectiveDate"
      label="有效时间"
      @change="changeEffectiveDate"
    >
      <el-date-picker
        style="width: 400px"
        :disabled="ifEdits"
        clearable
        v-model="form.effectiveDate"
        type="datetime"
        :picker-options="pickerOptions0"
        placeholder="请选择日期"
      ></el-date-picker>
    </el-form-item>
    <el-form-item label-width="0px" style="text-align: center; padding: 20px 0">
      <el-button
        v-if="editBtnStyle == 0"
        type="primary"
        @click="onSubmit"
        style="margin: 0 20px"
        >发布</el-button
      >
      <el-button
        v-if="editBtnStyle == 1"
        type="primary"
        @click="onSubmit"
        style="margin: 0 20px"
        >确认</el-button
      >
      <el-button
        type=""
        v-show="this.$route.query.backWeb == '1'"
        @click="cancel"
        style="margin: 0 20px"
        >取消</el-button
      >
      <el-button
        type=""
        v-show="
          this.$route.query.backWeb == '' ||
          this.$route.query.backWeb == undefined ||
          this.$route.query.backWeb == null
        "
        @click="cancel2"
        style="margin: 0 20px"
        >返回</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { http } from '@/utils/axios'
import * as api from '@/api/notice/noticeEdit'
import { Quill, quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'
import * as filters from '@/filters/index'

// 自定义字体大小
const Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px']
Quill.register(Size, true)

// 自定义字体类型
const fonts = [
  'simSum',
  'simHei',
  'Microsoft-YaHei',
  'KaiTi',
  'FangSong',
  'Arial',
  'Times-New-Roman',
  'sans-serif',
]
const Font = Quill.import('formats/font')
Font.whitelist = fonts
Quill.register(Font, true)

const Indent = Quill.import('formats/indent')
Indent.whitelist = [1]
Quill.register(Indent, true)

export default {
  name: 'NoticeEdit',
  components: {
    quillEditor,
  },
  data() {
    return {
      ifEdits: false,
      isEdit: true,
      //当前时间
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      form: {
        name: '',
        content: '',
        ground: '',
        uploadFileList: [],
        groupName: '',
        groupId: [],
        effectiveDate: '',
        type: 0,
        courseId: '',
        courseType: '',
        staus: 0,
        groups: [],
      },
      options: {
        placeholder: '请输入公告内容',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar',
        },
      },
      groundList: [],
      // groupId:'',
      file: [],
      editBtnStyle: 0,
      url: '',
    }
  },
  computed: {
    urlHost() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  methods: {
    getParams() {
      let id = this.$route.query.id
      api.getNotice({ id, uid: this.getUId }).then(({ data }) => {
        this.form = data.data
        console.log(data.data)
        this.form.groups = []
        let newArr
        newArr = data.data.groupId.split(',')
        for (let i = 0; i < newArr.length - 1; i++) {
          this.form.groups.push(newArr[i])
        }
        if (this.form.fileName) {
          this.file.push({ name: data.data.fileName, url: data.data.url })
        }

        this.url = data.data.url
      })
      // if(this.$route.query.vo!=null){
      // this.form.name = this.$route.query.vo.name
      // this.form.content = this.$route.query.vo.detailed
      // this.form.effectiveDate = this.$route.query.vo.effectiveDate
      // this.form=this.$route.query.vo
      // }
    },

    //点击文件列表中已上传的文件时的钩子
    // handlePreview(file){
    //
    //   let reqdata={
    //     id : this.$route.query.id
    //   }
    //   api2.getFile(reqdata).then(({ data }) => {
    //     api2.getFileName(reqdata).then(( data2 ) => {
    //       let files=new File([data], data2.data, {type: data.type});
    //       // const files = new window.File(
    //       //     [data],
    //       //     this.files[0].name,
    //       //     { type: this.files[0].type }
    //       // );
    //       console.log(files)
    //       let blob = new Blob([data], {type: `application/${data.type};charset=utf-8`});
    //       // 获取heads中的filename文件名
    //       let downloadElement = document.createElement('a');
    //       // 创建下载的链接
    //       let href = window.URL.createObjectURL(blob);
    //       downloadElement.href = href;
    //       // 下载后文件名
    //       downloadElement.download = files.name;
    //       document.body.appendChild(downloadElement);
    //       // 点击下载
    //       downloadElement.click();
    //       // 下载完成移除元素
    //       document.body.removeChild(downloadElement);
    //       // 释放掉blob对象
    //       window.URL.revokeObjectURL(href);
    //     })
    //   })
    // },
    handlePreview() {
      if (this.editBtnStyle == 0) {
        //新增 预览
        console.log(this.file)
        let formdata = new FormData()
        formdata.append('file', this.file)
        api.getFile2(formdata).then(({ data }) => {
          console.log(data)
          window.open(data)
        })
      } else {
        // console.log(this.form.fileName);
        window.open(this.url)
        // window.open(this.url+"?attname=xxxx.doc");
        // let name = this.form.fileName
        // let self = this
        // let x = new XMLHttpRequest()
        // x.open('GET', this.url, true)
        // x.responseType = 'blob'
        // x.onload = function () {
        //   //self.exportLoading = false;
        //   let url = window.URL.createObjectURL(x.response)
        //   let a = document.createElement('a')
        //   a.href = url
        //   a.download = self.form.fileName
        //   a.click()
        // }
        // x.send()
      }
    },

    //获取文件
    getFile() {
      let reqdata = {
        id: this.$route.query.id,
      }
      api.getFile(reqdata).then(({ data }) => {
        console.log(data)
        api.getFileName(reqdata).then((data2) => {
          let files = new File([data], data2.data, { type: data.type })
          // const files = new window.File(
          //     [data],
          //     this.files[0].name,
          //     { type: this.files[0].type }
          // );
          console.log(files)
          this.file = files
        })
      })
    },
    //获取小组
    getGroundList() {
      let page = 1
      let pageSize = 100
      let courseId = this.$route.query.courseId
      let infoType = 1
      console.log('courseId=' + courseId + 'courseId=1')
      api
        .getGroupList({ page, pageSize, courseId, infoType })
        .then(({ data }) => {
          this.groundList = data.data.list
        })
    },
    //面向小组选择
    handlePlat(res) {
      // console.log(res)
      // if(res==='全部'){
      //   this.form.groupId=res
      // }else{
      //   this.form.groupId=res
      // }
      this.$forceUpdate()
      if (this.form.groups.indexOf('全部') == -1) {
        //单选
        this.groundList.map((res) => {
          // console.log(res);
          res.disabled = false
        })
      } else {
        this.groundList.map((res) => {
          res.disabled = true
        })
        this.form.groups = ['全部']
      }
      console.log(this.form.groups)
    },
    //修改有效时间
    changeEffectiveDate(res) {},
    //      取消
    cancel() {
      // const url = 'NoticeList'
      // this.$emit('set-active-from-sub', url)
      // this.$router.push(url)
      history.go(-1)
    },
    cancel2() {
      if (this.$route.query.is_open == '2') {
        let url = window.location.protocol + '//' + window.location.host
        if (window.location.host == 'fxl.sce.scut.edu.cn') {
          url = url + '/zk'
        }
        window.top.location.href = `${url}/course/${this.$route.query.courseId}.html?tab=watchNotice`
      } else {
        history.go(-1)
      }
    },

    //文件作出改变
    handleChange(file, fileList) {
      this.file = file.raw
      console.log(file)
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },

    // 上传文件之前
    beforeUpload(file) {
      const allowList = [
        'image/png',
        'image/jpeg',
        'application/pdf',
        'application/doc',
        'application/zip',
        'application/rar',
      ]
      if (allowList.includes(file.type)) {
        return true
      } else {
        this.$message({
          type: 'warning',
          message: '只能上传doc、pdf、图片、压缩包类型',
        })
        return false
      }
    },

    // 文件上传
    uploadFn(items) {
      //      api.upload(items.file, this.form.idCard).then(({ data }) => {
      //        this.handleClose('success')
      //        this.$message({ type: 'success', message: '提交成功' })
      //      })
    },
    //当公告内容被编辑
    onEditorChange(event) {
      // console.log(event)
    },
    //提交修改
    onSubmit() {
      let reqdata = {}
      let ids = ''
      for (let i = 0; i < this.form.groups.length; i++) {
        ids += this.form.groups[i] + ','
      }
      if (this.editBtnStyle === '0') {
        //新增
        reqdata = {
          name: this.form.name || '',
          courseId: this.form.courseId || '',
          courseType: this.form.courseType || '',
          type: this.form.type,
          groupId: ids || '',
          createUserId: this.getUId() || '',
          // createDate:this.form.createDate||'',
          effectiveDate: filters.datetimeFormat(this.form.effectiveDate) || '',
          staus: this.form.staus,
          detailed: this.form.detailed || '',
        }
      } else if (this.editBtnStyle === '1') {
        //编辑
        reqdata = {
          id: this.$route.query.id || '',
          name: this.form.name || '',
          courseId: this.form.courseId || '',
          courseType: this.form.courseType || '',
          type: this.form.type,
          // groupId:this.form.groupId||'',
          groupId: ids || '',
          createUserId: this.form.createUserId || '',
          // createDate:this.form.createDate||'',
          effectiveDate: filters.datetimeFormat(this.form.effectiveDate) || '',
          // effectiveDate:'2020-01-02 12:00:00',
          // updateDate:"2021-02-06T03:16:32.000+00:00",
          staus: this.form.staus,
          detailed: this.form.detailed || '',
        }
      }
      let filedata = this.file
      console.log(filedata)
      api.editNotice(reqdata, filedata).then(({ data }) => {
        // data = data.data
        // this.tableData = data.list
        // this.total = data.total
        // this.loading = false
        if (data.code !== 100000) {
          this.$message({ type: 'error', message: data.msg || '发布失败' })
        } else {
          this.$message({ type: 'success', message: '发布成功' })
          let _this = this
          setTimeout(function () {
            const url = 'NoticeList'
            _this.$emit('set-active-from-sub', url)
            _this.$router.push({
              name: url,
              query: {
                courseId: _this.form.courseId,
                infoType: _this.form.courseType,
              },
            })
          }, 2000)
        }
      })
    },
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
  created() {
    this.form.courseId = this.$route.query.courseId
    this.form.courseType = this.$route.query.courseType
    const deitStyle = this.$route.query.edit_style
    this.editBtnStyle = deitStyle
    //判断是新增页面还是编辑页面
    if (deitStyle != '0') {
      this.getParams()
      // this.getFile()
    }
    if (deitStyle == '2') {
      this.ifEdits = true
      this.isEdit = false
    }
    if (this.$route.query.is_open == '2') {
      this.ifEdits = true
      this.isEdit = false
    }
    this.getGroundList()
  },
}
</script>

<style lang="scss" scoped>
.content {
  @include flex(center, flex-start);
  .info {
    width: 50%;
    border-right: 1px solid #4e5359;
    &:nth-last-child(1) {
      border-right: none;
    }
    .info-title {
      @include font(18px, #4e5359);
      text-align: center;
      padding-bottom: 20px;
    }
  }
  .el-form {
    .el-form-item {
      margin-left: 40px;
      width: 80%;
    }
  }
  /deep/.el-upload-list__item.is-success.focusing .el-icon-close-tip {
    display: none !important;
  }
}
</style>
<style>
.ql-editor {
  min-height: 300px;
}
.focusing .el-icon-close-tip {
  display: none !important;
}
</style>
